var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef, useCallback } from "react";
import { Link } from "react-router-dom";
import SubscriberService from "../services/SubscriberService";
import Notification from "../../App/components/Notification";
import Breadcrumbs from "../../App/components/Breadcrumbs";
import ModalConfirmImportSubscribers from "../components/ModalConfirmImportSubscribers";
import "../styles/ImportSubscribers.css";
import "../../App/styles/GlobalStyle.css";
import Title from "../../App/components/Title";
import DownloadingIcon from '@mui/icons-material/Downloading';
import ContainerServicesActionsSubscribers from "../components/ContainerServicesActionsSubscribers";
import useContentSuppliers from "../../App/hooks/useContentSuppliers";
import UploadArea from "../components/UploadArea";
import ConfirmAction from "../components/ConfirmAction";
function ImportSubscribers() {
    var _a;
    var _b = useState(), fileArchive = _b[0], setFileArchive = _b[1];
    var _c = useState(), fileData = _c[0], setFileData = _c[1];
    var _d = useState(), fileStatus = _d[0], setFileStatus = _d[1];
    var _e = useState(0), progress = _e[0], setProgress = _e[1];
    var _f = useState(false), imported = _f[0], setImported = _f[1];
    var _g = useState(), result = _g[0], setResult = _g[1];
    var _h = useState(), csvData = _h[0], setCsvData = _h[1];
    var _j = useState(), csvName = _j[0], setCsvName = _j[1];
    var _k = useState(false), modalConfirm = _k[0], setModalConfirm = _k[1];
    var _l = useState(), selectService = _l[0], setSelectService = _l[1];
    var _m = useState(false), showModalConfirmAction = _m[0], setShowModalConfirmAction = _m[1];
    var _o = useState(''), selectedAction = _o[0], setSelectedAction = _o[1];
    var _p = useState(''), selectedProductName = _p[0], setSelectedProductName = _p[1];
    var _q = useState(''), selectedProduct = _q[0], setSelectedProduct = _q[1];
    var _r = useState(null), showProducts = _r[0], setShowProducts = _r[1];
    var _s = useState(''), errorMessage = _s[0], setErrorMessage = _s[1];
    var navbarRef = useRef(null);
    var _t = useState(false), isDropdownOpen = _t[0], setIsDropdownOpen = _t[1];
    var _u = useContentSuppliers(), getAllContentGetSuppliersWithProducts = _u.getAllContentGetSuppliersWithProducts, contentSuppliers = _u.contentSuppliers;
    var isServiceSelected = useCallback(function () { return contentSuppliers === null || contentSuppliers === void 0 ? void 0 : contentSuppliers.some(function (item) { return item.id === selectService; }); }, [contentSuppliers, selectService]);
    var activeProducts = contentSuppliers.flatMap(function (supplier) { return supplier.content_supplier_products.filter(function (product) { return product.active === 1 && product.content_supplier_id === selectService; }); });
    var isUpdate = window.location.pathname.includes("subscribers/provision-many");
    useEffect(function () {
        var handleClickDropdown = function (event) {
            if (navbarRef.current && !navbarRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickDropdown);
        return function () {
            document.removeEventListener('mousedown', handleClickDropdown);
        };
    }, []);
    useEffect(function () {
        setFileData(undefined);
        setFileArchive(undefined);
        setCsvData(undefined);
        setProgress(0);
        setResult(undefined);
        setFileStatus("");
        setImported(false);
    }, [isUpdate]);
    useEffect(function () {
        var selectedService = localStorage.getItem('selectedService');
        var serviceId = selectedService ? parseInt(selectedService) : undefined;
        if (!selectService && contentSuppliers.length > 0) {
            var initialSupplierId = serviceId || contentSuppliers[0].id;
            setSelectService(initialSupplierId);
        }
    }, [selectService, contentSuppliers]);
    useEffect(function () {
        var inputElement = document.getElementById('input-file');
        if (!isServiceSelected()) {
            inputElement === null || inputElement === void 0 ? void 0 : inputElement.setAttribute('disabled', 'disabled');
        }
        else {
            inputElement === null || inputElement === void 0 ? void 0 : inputElement.removeAttribute('disabled');
        }
    }, [selectService, contentSuppliers]);
    useEffect(function () {
        getAllContentGetSuppliersWithProducts();
    }, []);
    function handleSubmit(event) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                event.preventDefault();
                setImported(true);
                return [2 /*return*/];
            });
        });
    }
    ;
    function handleServiceCall(serviceFunction, formData) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var res, results, err_1, message, results, message;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, serviceFunction(formData)];
                    case 1:
                        res = _c.sent();
                        results = res.data.result;
                        Notification().Loading.remove();
                        Notification().Notify.success("Importação finalizada");
                        setFileStatus("success");
                        setErrorMessage('');
                        handleResults(results);
                        setModalConfirm(false);
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _c.sent();
                        Notification().Loading.remove();
                        if (err_1.response && err_1.response.status === 422) {
                            message = err_1.response.data.response;
                            results = err_1.response.data.result;
                            Notification().Notify.warning(message);
                            setFileStatus("warning");
                            setErrorMessage('');
                            handleResults(results);
                        }
                        else if (err_1.response && err_1.response.status === 403) {
                            Notification().Notify.failure("Usuário não tem permissão para executar essa ação!");
                            setErrorMessage('');
                        }
                        else {
                            message = err_1.message || "Erro desconhecido";
                            Notification().Notify.failure(message);
                            setFileStatus("error");
                            setErrorMessage(message);
                            handleResults((_b = (_a = err_1.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.result);
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    ;
    function sendFile() {
        return __awaiter(this, void 0, void 0, function () {
            var formData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formData = new FormData();
                        if (!fileArchive)
                            return [2 /*return*/];
                        formData.append("file", fileArchive);
                        Notification().Loading.dots("Importando");
                        if (!(selectService === 1 && !isUpdate)) return [3 /*break*/, 2];
                        return [4 /*yield*/, handleServiceCall(SubscriberService.storeMany, formData)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        if (!(selectService === 2)) return [3 /*break*/, 4];
                        return [4 /*yield*/, handleServiceCall(SubscriberService.storeCSVMeliuz, formData)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        setModalConfirm(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    ;
    function handleDelete() {
        if (fileStatus === "warning") {
            Notification().Confirm.show("Iniciar uma nova importação", "Antes de excluir, certifique-se de ter baixado o relatório de erros! Deseja continuar?", "Cancelar", "Sim", function () {
                resetData();
            }, function () {
            }, {
                okButtonBackground: "#ccc",
                cancelButtonBackground: "#F44336"
            });
        }
        else {
            resetData();
        }
    }
    ;
    function resetData() {
        setImported(false);
        setFileData(undefined);
        setFileArchive(undefined);
        setFileStatus("");
        setProgress(0);
        setResult(undefined);
        setCsvData(undefined);
        setCsvName(undefined);
        setModalConfirm(false);
    }
    ;
    function handleResults(results) {
        if (isUpdate && selectService === 1) {
            var message = results.message || "";
            var regex = /(\d+) de (\d+) assinantes/;
            var match = message.match(regex);
            var registered = match ? parseInt(match[1]) : 0;
            var totalSubscribers = match ? parseInt(match[2]) : 0;
            setResult({
                totalServices: totalSubscribers,
                provisioned: registered,
                registered: registered,
                totalSubscribers: totalSubscribers,
            });
            if (results.error_report !== null && results.error_report !== undefined) {
                var lines = results.error_report.split(/\r\n|\n|\r/).filter(function (line) { return line.trim() !== ''; });
                var formatted = lines.map(function (line) { return line.split(','); });
                setCsvData(formatted);
                setCsvName("error-report.csv");
            }
        }
        else {
            setResult({
                totalServices: results.total_services,
                provisioned: results.activated,
                registered: results.registered,
                totalSubscribers: results.total_subscribers,
            });
            if (results.errors_report && typeof results.errors_report.csv === 'string' && results.errors_report.csv !== null) {
                var lines = results.errors_report.csv.split(/\r\n|\n|\r/).filter(function (line) { return line.trim() !== ''; });
                var formatted = lines.map(function (line) { return line.split(','); });
                setCsvData(formatted);
                setCsvName(results.errors_report.name);
            }
        }
    }
    ;
    function handleAction() {
        return __awaiter(this, void 0, void 0, function () {
            var header, formData;
            return __generator(this, function (_a) {
                header = csvData[0][0].toLowerCase() === 'cpf' ? csvData.slice(1) : csvData;
                if ((header === null || header === void 0 ? void 0 : header.length) === 0) {
                    Notification().Notify.failure("O arquivo CSV está vazio ou não possui assinantes para serem atualizados.");
                    return [2 /*return*/];
                }
                if (!fileArchive) {
                    Notification().Notify.warning("Por favor, envie um arquivo CSV.");
                    return [2 /*return*/];
                }
                if (!selectedAction) {
                    Notification().Notify.warning("Selecione uma ação.");
                    return [2 /*return*/];
                }
                if (!selectedProduct) {
                    Notification().Notify.warning("Selecione um produto.");
                    return [2 /*return*/];
                }
                formData = new FormData();
                formData.append("file", fileArchive);
                formData.append("action", selectedAction.toLowerCase());
                formData.append("product_id", String(selectedProduct));
                Notification().Loading.dots("Atualizando assinantes...");
                SubscriberService.provisionMany(formData)
                    .then(function (res) {
                    Notification().Loading.remove();
                    Notification().Notify.success(res.data.message);
                    setFileStatus("success");
                    setErrorMessage('');
                    handleResults(res.data);
                }).catch(function (error) {
                    var _a, _b;
                    Notification().Loading.remove();
                    var status = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status;
                    var data = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data;
                    if (status === 422) {
                        setFileStatus("warning");
                        setErrorMessage('');
                        handleResults(data);
                        Notification().Notify.failure((data === null || data === void 0 ? void 0 : data.message) || "Erro de validação");
                    }
                    else if (status === 403) {
                        Notification().Notify.failure("Você não tem permissão para executar essa ação.");
                        setErrorMessage('');
                    }
                    else if (data === null || data === void 0 ? void 0 : data.message) {
                        Notification().Notify.failure(data.message);
                        setFileStatus("error");
                        setErrorMessage(data.message);
                        handleResults(data);
                    }
                    else if (error.message) {
                        Notification().Notify.failure(error.message);
                        setFileStatus("error");
                        setErrorMessage(error.message);
                    }
                    else {
                        Notification().Notify.failure("Erro desconhecido");
                        setFileStatus("error");
                        setErrorMessage("Erro desconhecido");
                    }
                });
                return [2 /*return*/];
            });
        });
    }
    ;
    var breadcrumbsItens = [
        {
            name: "Gerenciar assinantes",
            route: "/subscribers"
        },
        {
            name: isUpdate ? "Atualizar assinantes" : "Importar assinantes",
            route: isUpdate ? "/subscribers/provision-many" : "/subscribers/import"
        }
    ];
    return (_jsxs("div", __assign({ className: "content-internal-padding" }, { children: [_jsxs("div", __assign({ className: "d-flex justify-content-between" }, { children: [_jsx(Title, { text: isUpdate ? "Atualizar assinantes" : "Importar assinantes", hr: false }), !isUpdate &&
                        _jsx("div", { children: _jsx(Link, __assign({ to: "/examples/subscribers-example.csv", target: "_blank", download: true }, { children: _jsxs("div", __assign({ className: "btn button-download provider-subscribersImport-example btn-import-subscribers", style: { width: "232px" } }, { children: [_jsx(DownloadingIcon, {}), " Baixar Relat\u00F3rio Modelo"] })) })) })] })), _jsx(Breadcrumbs, { itens: breadcrumbsItens }), _jsx("div", { children: _jsxs("div", { children: [_jsx(ContainerServicesActionsSubscribers, { isUpdate: isUpdate, contentSuppliers: contentSuppliers, selectService: selectService, setSelectService: setSelectService, setSelectedAction: setSelectedAction, selectedAction: selectedAction, selectedProductName: selectedProductName, setSelectedProduct: setSelectedProduct, navbarRef: navbarRef, setShowProducts: setShowProducts, showProducts: showProducts, activeProducts: activeProducts, setSelectedProductName: setSelectedProductName, isDropdownOpen: isDropdownOpen, setIsDropdownOpen: setIsDropdownOpen, setShowModalConfirmAction: setShowModalConfirmAction, fileData: fileData }), _jsxs("form", __assign({ onSubmit: handleSubmit, className: "provider-subscribersImport" }, { children: [_jsx(UploadArea, { isUpdate: isUpdate, fileData: fileData, setFileData: setFileData, setFileArchive: setFileArchive, imported: imported, setProgress: setProgress, progress: progress, fileStatus: fileStatus, result: result, csvData: csvData, csvName: csvName, setCsvData: setCsvData, selectService: selectService, onDelete: handleDelete, onConfirmImport: function () { return setModalConfirm(true); }, errorMessage: errorMessage, selectedAction: selectedAction }), _jsx(ModalConfirmImportSubscribers, { show: modalConfirm, closeModal: function () { return setModalConfirm(false); }, callbackSendFile: sendFile, selectService: selectService })] }))] }) }), _jsx(ConfirmAction, { show: showModalConfirmAction, closeModal: function () { return setShowModalConfirmAction(false); }, actionType: selectedAction.toLowerCase(), onConfirm: handleAction, isUpdate: isUpdate, productName: selectedProductName, cpfList: (_a = csvData === null || csvData === void 0 ? void 0 : csvData.map(function (r) { return r[0]; })) !== null && _a !== void 0 ? _a : [] })] })));
}
export default ImportSubscribers;
